var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionGrisMettreEnBap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5,17.3V6.6h1.6c0.6,0,1.2,0,1.7,0.2c0.4,0.1,0.8,0.3,1.1,0.6c0.3,0.3,0.6,0.6,0.7,1c0.2,0.4,0.3,0.8,0.3,1.3 c0,0.8-0.3,1.5-0.9,2c0.5,0.2,1,0.5,1.3,1c0.3,0.5,0.5,1.1,0.5,1.7c0,0.8-0.3,1.6-0.9,2.1c-0.3,0.3-0.7,0.6-1.2,0.7 c-0.6,0.1-1.2,0.2-1.8,0.2H0.5z M2.1,11.2h0.5c0.5,0.1,1-0.1,1.4-0.4c0.3-0.3,0.5-0.7,0.4-1.2c0-0.4-0.1-0.8-0.4-1.1 C3.6,8.2,3.2,8.1,2.7,8.1H2.1V11.2z M2.1,15.8h1c0.6,0,1.1-0.1,1.6-0.4c0.4-0.3,0.6-0.7,0.5-1.2c0-0.5-0.2-0.9-0.5-1.2 c-0.5-0.4-1.2-0.5-1.8-0.5H2.1V15.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6,10.6h1.6v6.8h-1.6v-0.7c-0.5,0.6-1.3,0.9-2.1,0.9c-0.9,0-1.7-0.3-2.3-1c-0.6-0.7-0.9-1.6-0.9-2.6 c0-0.9,0.3-1.8,0.9-2.5c0.6-0.6,1.4-1,2.3-1c0.8,0,1.6,0.4,2.1,1V10.6z M9.7,7.2l1.5-0.8L13.1,9l-0.9,0.5L9.7,7.2z M9.9,13.9 c0,0.6,0.2,1.1,0.5,1.6c0.3,0.4,0.8,0.6,1.4,0.6c0.5,0,1.1-0.2,1.4-0.6c0.4-0.4,0.5-1,0.5-1.5c0-0.6-0.2-1.1-0.5-1.6 c-0.4-0.4-0.9-0.6-1.4-0.6c-0.5,0-1,0.2-1.4,0.6C10.1,12.9,9.9,13.4,9.9,13.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1,13v4.4h-1.6V6.6h1.8c0.7,0,1.3,0,2,0.2c0.5,0.1,0.9,0.4,1.2,0.7c0.6,0.6,1,1.4,0.9,2.3c0,0.9-0.3,1.7-1,2.3 c-0.8,0.6-1.7,0.9-2.7,0.9L19.1,13z M19.1,11.5h0.6c1.5,0,2.2-0.6,2.2-1.7s-0.8-1.7-2.3-1.7h-0.5V11.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionGrisMettreEnBap);
export default __webpack_public_path__ + "static/media/action_gris_mettre-en-bap.ad19bc7e.svg";
export { ForwardRef as ReactComponent };